<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-icon>
          <v-icon>file_copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Clonar</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-card>
      <v-toolbar dense flat dark color="primary" v-if="!loading">
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0">{{ modalTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn class="mr-4" @click="resetForm" small outlined>
          Reiniciar
        </v-btn>
        <v-btn type="submit" :form="formId" small light depressed>
          Clonar
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-row>
            <v-progress-circular
              v-if="loading"
              class="my-12 prd-dialog-spinner"
              :size="50"
              :color="
                ['uccess', 'error', 'warning', 'info'][
                  Math.floor(Math.random() * 4)
                ]
              "
              indeterminate
            />
            <form-vjsf
              :key="formKey"
              :formId="formId"
              :formData="formData"
              @getFormData="getFormData($event)"
              @submitForm="submitForm($event)"
              style="width: 100%;"
              class="mt-2"
            />
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    formVjsf: () => import("@/components/FormVjsf.vue"),
  },
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
    dialogModelTitle: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    formKey: 0,
    formData: {
      id: null,
      model: {},
      schema: {},
      options: {},
    },
    loading: null,
  }),
  methods: {
    cancel() {
      this.dialog = false
      this.resetForm()
    },
    resetForm() {
      this.formKey += 1
    },
    getFormData() {
      this.loading = true
      this.service.newCloneItem(this.itemId).then(response => {
        this.formData = response.data
        this.loading = false
      })
    },
    submitForm() {
      this.service
        .createCloneItem(this.formData.id, this.formData.model)
        .then(response => {
          if (response.status === 201) {
            this.$emit("createTableItem", response.data.id)
            this.dialog = false
            this.resetForm()

            this.$notify({
              type: "success",
              title: this.$store.state.commonText.notification.successTitle,
              text: this.$store.state.commonText.notification.successText,
            })
          }
        })
        .catch(error => {
          this.$notify({
            type: "error",
            title: this.$store.state.commonText.notification.errorTitle,
            text:
              this.$store.state.commonText.notification.errorText +
              "<br>" +
              error,
          })
        })
      this.dialog = false
    },
  },
  computed: {
    formId() {
      return this.service.name() + "_" + this.itemId
    },
    modalTitle() {
      return (
        "Clonar " +
        this.formData.model[this.dialogModelTitle] +
        " (#" +
        this.itemId +
        ")"
      )
    },
  },
}
</script>

<style lang="scss" scoped></style>
